<template>
  <div>
      <p class="title is-5">
        Join ongoing meeting via link
          <StakeTooltip :label="tooltipLabel" position="bottom" tooltip-classes="tw-bg-slate-600 tw-text-white">
            <i class="fa fa-question-circle fa-sm tw-text-slate-400" />
          </StakeTooltip>
        </p>
    <div class="field has-addons">
      
        <input v-model="url" class="input" type="text" placeholder="Paste your meeting URL here">
      
      <div class="control">
        <div v-if="newInviteComplete" class="button is-success is-outlined">
          <i class="fa fa-check" />
          Invited
        </div>

        <div v-else-if="invitePending" class="button is-primary is-outlined " disabled>
          <i class="fa fa-spinner fa-spin" />
          Sending Invite
        </div>

        <button v-else
          class="button is-primary "
          @click="sendInvite">
          <span class="icon">
            <i class="fa fa-envelope" />
          </span>
          <span>
            Invite
          </span>
        </button>
      </div>
    </div>


    
    
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import StakeTooltip from '@stakeui/StakeTooltip.vue';

export default {
  name: 'InviteRecall',
  components: {
    StakeTooltip,
  },
  props: {
    entityExternalId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      url: null,
      newInviteComplete: null,
      invitePending: null,
      tooltipLabel: `
        The YourStake meeting agent is a bot that can join and record your meetings.
        Afterwards, we will process the recording to extract key information.
        We currently support Zoom, Google Meet, and Microsoft Teams.
      `,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() { },
  created() { },
  mounted() { },
  updated() { },
  methods: {
    async sendInvite() {
      this.invitePending = true;
      const defaultErrorMessage = 'We were unable to invite the bot to your meeting. Please try again or contact support.';

      const res = await fetch('/api/v1/recall/invite/', {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify({ meeting_url: this.url, entity_external_id: this.entityExternalId }),
      });

      this.invitePending = false;
      const data = await res.json();

      if (!res.ok || !data.id) {
        console.error('Failed to invite bot to meeting', data);
        alert(data.message || defaultErrorMessage);
        return;
      }

      if (data.id) this.newInviteComplete = true;
    },
  },
};
</script>


<style scoped>
.button-base {
  @apply tw-text-base;
  @apply tw-px-4 tw-py-2 tw-rounded-md tw-border-none;
  @apply tw-flex tw-gap-2 tw-items-center tw-justify-center;
}

.input-base {
  @apply tw-text-base;
  @apply tw-px-4 tw-py-2 tw-rounded-md;
  @apply tw-border tw-border-gray-300 tw-border-solid;
  @apply tw-bg-gray-50;
}
</style>
